import { useEffect, useState } from 'react'

/** Only the small provenance reader ticks; the report and prepared forecast frames stay resident. */
export function useReadClock(enabled: boolean): number {
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    if (!enabled) return
    let timer = 0
    const update = () => {
      clearTimeout(timer)
      if (document.hidden) return
      setNow(Date.now())
      timer = window.setTimeout(update, 60_010 - Date.now() % 60_000)
    }
    update(); document.addEventListener('visibilitychange', update)
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', update) }
  }, [enabled])
  return now
}
